import { render, staticRenderFns } from "./TestFormQuestionAnswer.vue?vue&type=template&id=61c5ae7f&scoped=true&"
import script from "./TestFormQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./TestFormQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5ae7f",
  null
  
)

export default component.exports